import React, { useState } from 'react';
import { fetchMarketingHealth } from '../api/marketing';
import { formatTimestamp } from '../utils/format';

export default function Settings() {
  const [health, setHealth] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCheck = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await fetchMarketingHealth();
      setHealth(data);
    } catch (err) {
      setError(err.message || 'Health check failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="panel">
      <h2>Backend Health</h2>
      <p>Check that the marketing API is reachable.</p>
      <button className="secondary" onClick={handleCheck} disabled={loading}>
        {loading ? 'Checking...' : 'Run Health Check'}
      </button>
      {error ? <p className="error">{error}</p> : null}
      {health ? (
        <div className="health-card">
          <p><strong>Status:</strong> {health.status}</p>
          <p><strong>Timestamp:</strong> {formatTimestamp(health.timestamp)}</p>
        </div>
      ) : null}
    </section>
  );
}
